<template>
  <b-card v-if="loadServicesAndActions">
    <center>
      <b-spinner
        variant="primary"
        label="Spinning"
      />
    </center>
  </b-card>
  <div v-else-if="normalizedServicesAndActions">
    <!-- Service Type Header -->
    <b-card
      v-if="normalizedServicesAndActions.serviceType"
      class="mb-2"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center flex-grow-1">
          <div
            v-if="normalizedServicesAndActions.serviceType.color"
            class="service-type-indicator mr-2"
            :style="{ backgroundColor: normalizedServicesAndActions.serviceType.color }"
          />
          <div class="flex-grow-1">
            <h5 class="mb-0">
              <feather-icon
                v-if="normalizedServicesAndActions.serviceType.icon"
                :icon="normalizedServicesAndActions.serviceType.icon"
                size="18"
                class="mr-1"
              />
              {{ normalizedServicesAndActions.serviceType.name_ar || normalizedServicesAndActions.serviceType.name }}
            </h5>
            <small
              v-if="normalizedServicesAndActions.serviceType.description"
              class="text-muted"
            >
              {{ normalizedServicesAndActions.serviceType.description }}
            </small>
          </div>
          <b-badge
            v-if="normalizedServicesAndActions.serviceType.is_active === false"
            variant="secondary"
            class="ml-2"
          >
            غير نشط
          </b-badge>
        </div>
        <div class="d-flex align-items-center">
          <b-button
            v-b-tooltip.hover.top="'تحديث البيانات'"
            variant="outline-primary"
            size="sm"
            class="ml-2"
            :disabled="loadServicesAndActions"
            @click="init"
          >
            <b-spinner
              v-if="loadServicesAndActions"
              small
              class="mr-1"
            />
            <feather-icon
              v-else
              icon="RefreshCwIcon"
              size="14"
              class="mr-1"
            />
            تحديث
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            class="ml-2"
            @click="openEditModal"
          >
            <feather-icon
              icon="EditIcon"
              size="14"
              class="mr-1"
            />
            تعديل
          </b-button>
        </div>
      </div>
    </b-card>

    <!-- Services with Actions (New Structure) -->
    <b-row v-if="normalizedServicesAndActions.projectServices && normalizedServicesAndActions.projectServices.length">
      <b-col
        v-for="projectService in normalizedServicesAndActions.projectServices"
        :key="projectService.id"
        md="6"
        lg="4"
        class="mb-3"
      >
        <b-card>
          <div class="d-flex justify-content-between align-items-start mb-3">
            <div class="flex-grow-1">
              <h6 class="mb-0">
                {{ projectService.service.name }}
              </h6>
              <small class="text-muted">{{ projectService.service.service_code }}</small>
            </div>
            <b-badge
              variant="info"
              class="ml-2"
            >
              {{ (serviceActionsMap[projectService.service_id] || []).length }} إجراءات
            </b-badge>
            <b-button
              variant="outline-danger"
              size="sm"
              class="ml-2"
              @click="confirmDeleteService(projectService.service_id, projectService.id)"
            >

              <feather-icon
                icon="TrashIcon"
                size="14"
              />
            </b-button>
          </div>

          <!-- Loading Actions -->
          <div
            v-if="loadingActions[projectService.service_id]"
            class="text-center py-3"
          >
            <b-spinner
              variant="primary"
              size="sm"
              label="جاري التحميل..."
            />
          </div>

          <!-- Actions List with Checkboxes -->
          <div
            v-else-if="serviceActionsMap[projectService.service_id] && serviceActionsMap[projectService.service_id].length"
            class="service-actions-list"
          >
            <div
              v-for="(action, index) in serviceActionsMap[projectService.service_id]"
              :key="action.id"
              class="action-item mb-2 pb-2"
              :class="{ 'border-bottom': index < serviceActionsMap[projectService.service_id].length - 1 }"
            >
              <div class="d-flex align-items-start">
                <b-form-checkbox
                  :checked="isActionSelected(action.id)"
                  class="mr-2"
                  @change="updateAction(action.id, $event)"
                />
                <div class="flex-grow-1">
                  <div class="d-flex justify-content-between align-items-start">
                    <div class="flex-grow-1">
                      <strong>{{ action.name }}</strong>
                      <!-- <b-badge
                        :variant="action.is_required ? 'primary' : 'secondary'"
                        class="ml-1"
                        size="sm"
                      >
                        {{ action.responsibility_type_label || action.default_responsibility_type || 'اختياري' }}
                      </b-badge> -->
                    </div>
                    <small
                      v-if="action.estimated_hours"
                      class="text-muted"
                    >
                      {{ action.estimated_hours }} ساعة
                    </small>
                  </div>
                  <!-- <div v-if="action.description" class="text-muted small mb-1">
                    {{ action.description }}
                  </div> -->

                </div>

              </div>
            </div>
          </div>

          <b-alert
            v-else
            variant="warning"
            show
            class="mb-0"
          >
            لا توجد إجراءات متاحة لهذه الخدمة
          </b-alert>
        </b-card>
      </b-col>
    </b-row>

    <!-- Legacy Structure Support (servicesWithActions) -->
    <b-row v-else-if="normalizedServicesAndActions.servicesWithActions && groupedServices && Object.keys(groupedServices).length">
      <b-col
        v-for="(actions, serviceName) in groupedServices"
        :key="serviceName"
        md="6"
        lg="4"
        class="mb-3"
      >
        <b-card>
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div>
              <h6 class="mb-0">
                {{ actions[0].service.name }}
              </h6>
              <small class="text-muted">{{ actions[0].service.service_code }}</small>
            </div>
            <b-badge variant="info">
              {{ actions.length }} {{ actions.length === 1 ? 'إجراء' : 'إجراءات' }}
            </b-badge>
          </div>

          <div class="service-actions-list">
            <div
              v-for="(action, index) in actions"
              :key="action.id"
              class="action-item mb-2 pb-2"
              :class="{ 'border-bottom': index < actions.length - 1 }"
            >
              <div class="d-flex justify-content-between align-items-start mb-1">
                <div class="flex-grow-1">
                  <strong>{{ action.name }}</strong>
                  <b-badge
                    :variant="action.is_required ? 'primary' : 'secondary'"
                    class="ml-1"
                    size="sm"
                  >
                    {{ action.responsibility_type_label }}
                  </b-badge>
                </div>
                <small
                  v-if="action.estimated_hours"
                  class="text-muted"
                >
                  {{ action.estimated_hours }} ساعة
                </small>
              </div>
              <div
                v-if="action.description"
                class="text-muted small mb-1"
              >
                {{ action.description }}
              </div>
              <div class="d-flex align-items-center flex-wrap">
                <b-badge
                  v-if="action.has_tasks"
                  variant="success"
                  class="mr-1"
                  size="sm"
                >
                  {{ action.tasks_count }} مهام
                </b-badge>
                <small class="text-muted">
                  <feather-icon
                    icon="CalendarIcon"
                    size="12"
                    class="mr-1"
                  />
                  {{ formatDate(action.created_at) }}
                </small>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <div
      v-else
      class="text-center bg-white p-2 d-flex justify-content-between"
    >
      <p>لا توجد خدمات أو إجراءات متاحة</p>
      <b-button
        variant="primary"
        size="sm"
        class="ml-2"
        @click="openEditModal"
      >
        <feather-icon
          icon="EditIcon"
          size="14"
          class="mr-1"
        />
        إضافة خدمة
      </b-button>

    </div>

    <!-- Edit Modal -->
    <b-modal
      id="edit-services-modal"
      v-model="showEditModal"
      title="تعديل نوع الخدمة والخدمات والإجراءات"
      size="lg"
      :ok-disabled="updating"
      no-close-on-backdrop
      hide-footer
      @hidden="resetEditForm"
    >
      <div
        v-if="updating"
        class="text-center py-3"
      >
        <b-spinner
          variant="primary"
          label="جاري الحفظ..."
        />
      </div>
      <div v-else>

        <!-- Hierarchical Item Component for Service Selection -->
        <b-form-group
          label="الخدمات والإجراءات"
          class="mb-3"
        >
          <HierarchicalItem
            ref="hierarchicalItem"
            @selection-changed="handleServiceSelectionChanged"
          />
        </b-form-group>

        <!-- Selected Services Preview -->
        <!-- <div v-if="editForm.service_action_ids && editForm.service_action_ids.length > 0" class="mt-3">
          <h6>الخدمات المحددة:</h6>
          <b-alert variant="info" show class="mb-2">
            <div v-for="(item, index) in editForm.service_action_ids" :key="index" class="mb-1">
              <strong>الخدمة:</strong> {{ getServiceName(item.service_id) }}
              <span v-if="item.action_ids && item.action_ids.length > 0">
                - <strong>الإجراءات:</strong> {{ item.action_ids.length }}
              </span>
            </div>
          </b-alert>
        </div> -->
      </div>

      <div class="w-100 d-flex justify-content-between">
        <b-button
          variant="secondary"
          :disabled="updating"
          @click="showEditModal = false"
        >
          إلغاء
        </b-button>
        <b-button
          variant="primary"
          :disabled="updating || loadingSelectionActions || !editForm.service_type_id"
          @click="saveChanges"
        >
          <b-spinner
            v-if="updating || loadingSelectionActions"
            small
            class="mr-1"
          />
          <feather-icon
            v-else
            icon="SaveIcon"
            size="14"
            class="mr-1"
          />
          {{ updating ? 'جاري الحفظ...' : (loadingSelectionActions ? 'جاري تحميل الإجراءات...' : 'حفظ') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  VBTooltip, BCard, BCardHeader, BCardBody, BRow, BCol, BTable, BSpinner, BBadge, BAlert, BButton, BModal, BFormGroup, BFormCheckbox,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import HierarchicalItem from '@/views/modules/Components/HierarchicalItem.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'TransactionsAndServicesComponent',
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BTable,
    BSpinner,
    BBadge,
    BAlert,
    BButton,
    BModal,
    BFormGroup,
    BFormCheckbox,
    HierarchicalItem,
    vSelect,
  },
  computed: {

    projectId() {
      return this.$route.params.id
    },
    ...mapGetters({
      servicesAndActions: 'projects/servicesAndActions',
      loadServicesAndActions: 'projects/loadServicesAndActions',
      serviceTypes: 'serviceTypes/serviceTypes',
      services: 'services/services',
    }),
    normalizedServicesAndActions() {
      if (!this.servicesAndActions) return null
      // New structure: { projectServices: [], serviceType: {}, actionsIds: [] }
      if (this.servicesAndActions.projectServices && Array.isArray(this.servicesAndActions.projectServices)) {
        return this.servicesAndActions
      }
      // Legacy structure: { serviceType: {}, servicesWithActions: [] }
      if (this.servicesAndActions.serviceType && Array.isArray(this.servicesAndActions.servicesWithActions)) {
        return this.servicesAndActions
      }
      // If servicesAndActions is an array, wrap it
      if (Array.isArray(this.servicesAndActions)) {
        return { serviceType: null, servicesWithActions: this.servicesAndActions }
      }
      // If nested in data property
      if (this.servicesAndActions.data) {
        if (this.servicesAndActions.data.projectServices) {
          return this.servicesAndActions.data
        }
        if (this.servicesAndActions.data.serviceType || Array.isArray(this.servicesAndActions.data.servicesWithActions)) {
          return this.servicesAndActions.data
        }
      }
      // If it's an object with servicesWithActions array
      if (Array.isArray(this.servicesAndActions.servicesWithActions)) {
        return this.servicesAndActions
      }
      return null
    },
    groupedServices() {
      const data = this.normalizedServicesAndActions
      if (!data?.servicesWithActions || !Array.isArray(data.servicesWithActions)) {
        return {}
      }
      const groups = {}
      data.servicesWithActions.forEach(item => {
        const serviceKey = item.service?.name || item.service?.service_code || 'غير محدد'
        if (!groups[serviceKey]) {
          groups[serviceKey] = []
        }
        groups[serviceKey].push(item)
      })
      // Sort actions within each service by order
      Object.keys(groups).forEach(key => {
        groups[key].sort((a, b) => (a.order || 0) - (b.order || 0))
      })
      return groups
    },
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      serviceActionsIds: [],
      showEditModal: false,
      updating: false,
      editForm: {
        service_type_id: null,
        service_action_ids: [], // Legacy format
        actionsIds: [], // New format: array of selected action IDs
      },
      handledServicesActionsIds: [],
      loadingSelectionActions: false,
      pendingActionRequests: 0,
      selectionRequestId: 0,
      servicesTree: [],
      serviceActions: [],
      serviceActionsMap: {}, // Map of serviceId -> array of actions
      loadingActions: {}, // Map of serviceId -> loading state
      actionsMap: {}, // Map of actionId -> action object for display
    }
  },
  watch: {
    'editForm.service_type_id': function (newVal) {
      // Reset service selection when service type changes
      if (this.$refs.hierarchicalItem && newVal) {
        this.$refs.hierarchicalItem.serviceTypeId = newVal
        this.editForm.service_action_ids = []
      }
    },
  },
  mounted() {
    this.init()
    this.callServices()
  },
  methods: {
    callServices() {
      this.$store.dispatch('services/fetchServices')
    },
    init() {
      this.$store.dispatch('projects/getServicesAndActions', {
        id: this.projectId,
      }).then(() => {
        this.serviceActionsIds = this.servicesAndActions.actionsIds
        // After loading services and actions, fetch actions for each service
        this.fetchActionsForAllServices()
      })
      this.$store.dispatch('serviceTypes/fetchServiceTypes',{is_active:1})
    },
    async fetchActionsForAllServices() {
      const normalized = this.normalizedServicesAndActions
      if (!normalized || !normalized.projectServices) return

      // Fetch actions for each service
      for (const projectService of normalized.projectServices) {
        const serviceId = projectService.service_id
        if (serviceId && !this.serviceActionsMap[serviceId]) {
          await this.fetchActionsForService(serviceId)
        }
      }
    },
    async fetchActionsForService(serviceId) {
      if (this.loadingActions[serviceId]) return // Already loading

      this.$set(this.loadingActions, serviceId, true)

      try {
        const response = await this.$store.dispatch('myServices/getServiceActions', serviceId)

        // Handle different possible response structures
        let actions = []
        if (response?.data) {
          if (Array.isArray(response.data)) {
            actions = response.data
          } else if (response.data.data && Array.isArray(response.data.data)) {
            actions = response.data.data
          } else if (Array.isArray(response.data.actions)) {
            actions = response.data.actions
          }
        }

        // Store actions in serviceActionsMap
        this.$set(this.serviceActionsMap, serviceId, actions)

        // Also update actionsMap for individual action lookup
        actions.forEach(action => {
          const actionId = action.id || action.service_action_id || action.action_id
          if (actionId) {
            this.$set(this.actionsMap, actionId, action)
          }
        })
      } catch (error) {
        console.error(`Error fetching actions for service ${serviceId}:`, error)
        this.$set(this.serviceActionsMap, serviceId, [])
      } finally {
        this.$set(this.loadingActions, serviceId, false)
      }
    },
    isActionSelected(actionId) {
      return this.serviceActionsIds.includes(actionId)
    },
    updateAction(actionId, checked) {
      if (checked) {
        this.serviceActionsIds.push(actionId)
      } else {
        this.serviceActionsIds = this.serviceActionsIds.filter(id => id !== actionId)
      }
      const doAction = checked ? 'store' : 'delete'
      this.$store.dispatch('projects/checkServiceAction', {
        id: this.projectId,
        query: {
          service_action_id: actionId,
          doAction,
        },
      })
    },
    formatDate(dateString) {
      if (!dateString) return ''
      try {
        const date = new Date(dateString)
        return date.toLocaleDateString('ar-EG', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      } catch (e) {
        return dateString
      }
    },
    openEditModal() {
      const normalized = this.normalizedServicesAndActions
      if (normalized) {
        // Initialize edit form with current values
        this.editForm.service_type_id = normalized.serviceType?.id || null

        // New structure: initialize actionsIds
        if (normalized.actionsIds && Array.isArray(normalized.actionsIds)) {
          this.editForm.actionsIds = [...normalized.actionsIds]
        } else {
          this.editForm.actionsIds = []
        }

        // Legacy structure: convert servicesWithActions to service_action_ids format
        if (normalized.servicesWithActions && Array.isArray(normalized.servicesWithActions)) {
          const grouped = {}
          normalized.servicesWithActions.forEach(item => {
            const serviceId = item.service?.id || item.service_id
            const actionId = item.service_action?.id || item.service_action_id

            if (serviceId && actionId) {
              if (!grouped[serviceId]) {
                grouped[serviceId] = { service_id: serviceId, action_ids: [] }
              }
              if (!grouped[serviceId].action_ids.includes(actionId)) {
                grouped[serviceId].action_ids.push(actionId)
              }
            }
          })
          this.editForm.service_action_ids = Object.values(grouped)
        }

        // Fetch actions for all services in new structure
        if (normalized.projectServices && Array.isArray(normalized.projectServices)) {
          normalized.projectServices.forEach(projectService => {
            const serviceId = projectService.service_id
            if (serviceId && !this.serviceActionsMap[serviceId]) {
              this.fetchActionsForService(serviceId)
            }
          })
        }
      }
      this.showEditModal = true

      // Set service type in hierarchical item after modal is shown
      this.$nextTick(() => {
        if (this.$refs.hierarchicalItem && this.editForm.service_type_id) {
          this.$refs.hierarchicalItem.serviceTypeId = this.editForm.service_type_id
          // Set selected service IDs (legacy)
          if (this.editForm.service_action_ids && this.editForm.service_action_ids.length > 0) {
            this.$refs.hierarchicalItem.selectedServiceIds = this.editForm.service_action_ids.map(item => item.service_id)
          }
        }
      })
    },
    resetEditForm() {
      this.editForm = {
        service_type_id: null,
        service_action_ids: [], // Legacy format
        actionsIds: [], // New format
      }
      this.handledServicesActionsIds = []
      this.loadingSelectionActions = false
      this.pendingActionRequests = 0
      this.selectionRequestId = 0
      if (this.$refs.hierarchicalItem) {
        this.$refs.hierarchicalItem.selectedServiceIds = []
        this.$refs.hierarchicalItem.serviceTypeId = null
      }
    },
    async handleServiceSelectionChanged(selection) {
      if (!selection || !selection.selectedServiceIds) return

      const selectedServiceIds = selection.selectedServiceIds || []
      const serviceTypeId = selection.service_type_id || this.editForm.service_type_id

      if (serviceTypeId && serviceTypeId !== this.editForm.service_type_id) {
        this.editForm.service_type_id = serviceTypeId
      }

      const requestId = ++this.selectionRequestId
      this.pendingActionRequests += 1
      this.loadingSelectionActions = true

      const serviceActionIds = []

      try {
        for (const serviceId of selectedServiceIds) {
          const cached = this.handledServicesActionsIds.find(item => item.service_id === serviceId)
          if (cached && cached.action_ids && cached.action_ids.length > 0) {
            serviceActionIds.push(cached)
            continue
          }

          const existing = this.editForm.service_action_ids.find(item => item.service_id === serviceId)
          if (existing && existing.action_ids && existing.action_ids.length > 0) {
            serviceActionIds.push(existing)
            continue
          }

          try {
            const response = await this.$store.dispatch('myServices/getServiceActions', serviceId)
            const actions = response?.data || []
            const actionIds = Array.isArray(actions)
              ? actions.map(action => action.id).filter(id => id !== undefined && id !== null)
              : []

            serviceActionIds.push({
              service_id: serviceId,
              action_ids: actionIds,
            })
          } catch (error) {
            serviceActionIds.push({
              service_id: serviceId,
              action_ids: existing?.action_ids || [],
            })
          }
        }

        if (requestId === this.selectionRequestId) {
          this.handledServicesActionsIds = serviceActionIds
          this.editForm.service_action_ids = [...serviceActionIds]
        }
      } finally {
        this.pendingActionRequests = Math.max(0, this.pendingActionRequests - 1)
        this.loadingSelectionActions = this.pendingActionRequests > 0
      }
    },
    async saveChanges() {
      if (!this.editForm.service_type_id) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطأ',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'يرجى اختيار نوع الخدمة',
          },
        })
        return
      }

      this.updating = true

      try {
        console.log('this.editForm (reactive):', this.editForm)
        console.log('this.handledServicesActionsIds:', this.handledServicesActionsIds)
        console.log('service_action_ids in console:', this.editForm.service_action_ids)

        // FIX: Convert reactive object to plain object
        const payload = {
          service_type_id: this.editForm.service_type_id,
          service_action_ids: this.editForm.service_action_ids
            ? JSON.parse(JSON.stringify(this.editForm.service_action_ids)) : [],
        }

        console.log('Payload to send:', payload)

        await this.$store.dispatch('projects/updateServicesAndActions', {
          id: this.projectId,
          query: payload, // Use the plain object payload
        })

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'تم التحديث',
            icon: 'CheckIcon',
            variant: 'success',
            text: 'تم تحديث نوع الخدمة والإجراءات بنجاح',
          },
        })

        // Refresh data
        await this.$store.dispatch('projects/getServicesAndActions', {
          id: this.projectId,
        })

        // Update serviceActionsIds from refreshed data
        const response = await this.$store.dispatch('projects/getServicesAndActions', {
          id: this.projectId,
        })
        if (response?.data?.actionsIds && Array.isArray(response.data.actionsIds)) {
          this.serviceActionsIds = response.data.actionsIds
        }

        // Clear and refetch actions for all services
        this.serviceActionsMap = {}
        await this.fetchActionsForAllServices()

        this.showEditModal = false
        this.resetEditForm()
      } catch (error) {
        let errorMessage = 'حدث خطأ أثناء التحديث'

        if (error.response?.status === 422 && error.response.data?.errors) {
          const { errors } = error.response.data
          const errorMessages = Object.values(errors).flat()
          errorMessage = errorMessages.join(', ')
        } else if (error.response?.data?.message) {
          errorMessage = error.response.data.message
        } else if (error.message) {
          errorMessage = error.message
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطأ',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: errorMessage,
          },
        })
      } finally {
        this.updating = false
      }
    },
    confirmDeleteService(serviceId, projectServiceId) {
      const serviceName = this.getServiceName(serviceId)
      this.$bvModal.msgBoxConfirm(
        `هل أنت متأكد من حذف الخدمة "${serviceName}"؟`,
        {
          title: 'تأكيد الحذف',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'حذف',
          cancelTitle: 'إلغاء',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      ).then(value => {
        if (value) {
          this.deleteService(serviceId, projectServiceId)
        }
      })
    },
    async deleteService(serviceId, projectServiceId) {
      this.$store.dispatch('projects/deleteProjectService', {
        id: projectServiceId,
      }).then(response => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'تم الحذف',
            icon: 'CheckIcon',
            variant: 'success',
            text: 'تم حذف الخدمة بنجاح',
          },
        })
        // Refresh data
        this.init()
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطأ',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error.response?.data?.message || 'حدث خطأ أثناء حذف الخدمة',
          },
        })
      })
    },
    confirmDeleteAction(actionId, serviceId) {
      const actionName = this.getActionName(actionId)
      const serviceName = this.getServiceName(serviceId)
      this.$bvModal.msgBoxConfirm(
        `هل أنت متأكد من حذف الإجراء "${actionName}" من الخدمة "${serviceName}"؟`,
        {
          title: 'تأكيد الحذف',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'حذف',
          cancelTitle: 'إلغاء',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      ).then(value => {
        if (value) {
          this.deleteAction(actionId)
        }
      })
    },
    async deleteAction(actionId) {
      try {
        const normalized = this.normalizedServicesAndActions
        let updatedActionsIds = normalized?.actionsIds ? [...normalized.actionsIds] : []
        updatedActionsIds = updatedActionsIds.filter(id => id !== actionId)

        // Update via API
        const formData = new FormData()
        const data = {
          service_type_id: normalized?.serviceType?.id || null,
          actionsIds: updatedActionsIds,
        }
        formData.append('data', JSON.stringify(data))

        await this.$store.dispatch('projects/updateServicesAndActions', {
          id: this.projectId,
          query: formData,
        })

        // Refresh data
        await this.$store.dispatch('projects/getServicesAndActions', {
          id: this.projectId,
        })

        // Update editForm if in edit mode
        if (this.showEditModal && this.editForm.actionsIds) {
          this.editForm.actionsIds = this.editForm.actionsIds.filter(id => id !== actionId)
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'تم الحذف',
            icon: 'CheckIcon',
            variant: 'success',
            text: `تم حذف الإجراء "${this.getActionName(actionId)}" بنجاح`,
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطأ',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error.response?.data?.message || 'حدث خطأ أثناء حذف الإجراء',
          },
        })
      }
    },
    getServiceName(serviceId) {
      const normalized = this.normalizedServicesAndActions

      // New structure: check projectServices
      if (normalized && normalized.projectServices) {
        const projectService = normalized.projectServices.find(ps => (ps.service?.id || ps.service_id) === serviceId)
        if (projectService) {
          return projectService.service?.name || projectService.service?.service_code || `خدمة ${serviceId}`
        }
      }

      // Legacy structure: check servicesWithActions
      if (normalized && normalized.servicesWithActions) {
        const item = normalized.servicesWithActions.find(item => (item.service?.id || item.service_id) === serviceId)
        if (item) {
          return item?.service?.name || item?.service?.service_code || `خدمة ${serviceId}`
        }
      }

      return `خدمة ${serviceId}`
    },
    getActionName(actionId) {
      // First, try to get from actionsMap (actions we just fetched)
      if (this.actionsMap[actionId]) {
        const action = this.actionsMap[actionId]
        return action.name || action.action_name || action.service_action_name || `إجراء ${actionId}`
      }

      // Try from normalized data (existing project actions) - legacy structure
      const normalized = this.normalizedServicesAndActions
      if (normalized && normalized.servicesWithActions) {
        const item = normalized.servicesWithActions.find(item => {
          const id = item.service_action?.id || item.service_action_id || item.id
          return id === actionId
        })
        if (item) {
          const name = item.service_action?.name || item.name || item.service_action?.action_name || item.service_action_name
          if (name) return name
        }
      }

      // Try to get from store if available
      const serviceActions = this.$store.getters['myServices/serviceActions']
      if (Array.isArray(serviceActions)) {
        const action = serviceActions.find(a => {
          const id = a.id || a.service_action_id || a.action_id
          return id === actionId
        })
        if (action) {
          const name = action.name || action.action_name || action.service_action_name
          if (name) return name
        }
      }

      return `إجراء ${actionId}`
    },
  },
}
</script>

<style scoped>
.service-type-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.service-actions-list {
  max-height: 500px;
  overflow-y: auto;
}

.action-item:last-child {
  border-bottom: none !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.action-item .border-bottom {
  border-color: #e0e0e0 !important;
}
</style>
